/**
 * Extract a human-readable error message from API error responses.
 * FastAPI returns 422 validation errors with detail as an array of objects:
 * [{ type, loc, msg, input, ctx }]
 * Other errors may return detail as a string.
 */
export function getApiErrorMessage(err: any, fallback = 'Something went wrong'): string {
  if (!err?.response?.data?.detail) {
    return err?.message || err?.response?.data?.message || fallback;
  }
  const detail = err.response.data.detail;
  if (typeof detail === 'string') {
    return detail;
  }
  if (Array.isArray(detail) && detail.length > 0) {
    const first = detail[0];
    if (typeof first === 'object' && first !== null && 'msg' in first) {
      return String(first.msg);
    }
    if (typeof first === 'string') {
      return first;
    }
  }
  return fallback;
}
